import storeConstants from '@/utils/constants/store';

const hasActionCreate = (options) => {
    return options && options.actions && options.actions.create ? options.actions.create : false;
};

const hasActionUpdate = (options) => {
    return options && options.actions && options.actions.update ? options.actions.update : false;
};

const hasActionDelete = (options) => {
    return options && options.actions && options.actions.delete ? options.actions.delete : false;
};

const hasActionSelect = (options) => {
    return options && options.actions && options.actions.select ? options.actions.select : false;
};

const getActionGetDefaultOptions = (options) => {
    return options &&
        options.actionsOptions &&
        options.actionsOptions.get &&
        options.actionsOptions.get.defaultOptions
        ? options.actionsOptions.get.defaultOptions
        : {
              refresh: false,
              offset: 0,
              limit: storeConstants.ITEMS_PER_PAGE,
          };
};

const getActionControlItem = (options) => {
    return (
        (options &&
            options.actionsOptions &&
            options.actionsOptions.get &&
            options.actionsOptions.get.controlItems) ||
        storeConstants.ACTION_GET_CONTROL_ITEMS.ALL
    );
};

const getNormalizeItemFn = (options) => {
    const optionsNormalizeItemFn =
        options && options.normalizeItemFn ? options.normalizeItemFn : false;
    let normalizeItemFn;

    if (optionsNormalizeItemFn || hasActionSelect()) {
        normalizeItemFn = (item) => {
            let ret = { ...item };

            if (optionsNormalizeItemFn) {
                ret = optionsNormalizeItemFn(ret);
            }
            if (hasActionSelect) {
                ret = {
                    ...ret,
                    _selected: false,
                };
            }

            return ret;
        };
    }

    return normalizeItemFn;
};

export default {
    getNormalizeItemFn,
    hasActionCreate,
    hasActionUpdate,
    hasActionDelete,
    hasActionSelect,
    getActionControlItem,
    getActionGetDefaultOptions,
};
